// extracted by mini-css-extract-plugin
export default {"ContactContainer":"ContactInfo_ContactContainer__peNI0"};